<template>
  <v-app dark class="layout-auth">
    <div class="layout-auth__bg" aria-hidden="true" />
    <div class="layout-auth__curves" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1600 900">
        <defs>
          <linearGradient id="curveGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="rgba(108,230,240,0)" />
            <stop offset="50%" stop-color="rgba(108,230,240,0.6)" />
            <stop offset="100%" stop-color="rgba(108,230,240,0)" />
          </linearGradient>
        </defs>
        <path class="curve curve--faint" d="M -100 700 Q 400 520, 800 600 T 1700 540" />
        <path class="curve curve--faint" d="M -100 760 Q 350 600, 800 650 T 1700 600" />
        <path class="curve" stroke="url(#curveGrad)" d="M -100 800 Q 380 670, 800 720 T 1700 680" />
        <path class="curve curve--glow" stroke="url(#curveGrad)" d="M -100 820 Q 400 720, 800 760 T 1700 740" />
        <path class="curve curve--faint" d="M -100 880 Q 420 800, 800 820 T 1700 820" />
        <path class="curve curve--faint" d="M 100 50 Q 500 200, 1000 120 T 1700 80" />
        <path class="curve curve--faint" d="M 200 120 Q 600 250, 1100 200 T 1700 180" />
      </svg>
    </div>
    <v-main>
      <router-view :key="$route.path" />
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({}),
}
</script>

<style lang="scss">
/* IMPORTANT: estos estilos son NO-scoped a proposito.
   El <v-app> de Vuetify aplica su propio background al wrap interno
   (.v-application--wrap). Necesitamos pisarlo en el contexto correcto. */

.layout-auth.v-application {
  background: #04122a !important;
  position: relative;
  overflow: hidden;

  .v-application--wrap {
    background: transparent !important;
    min-height: 100vh;
    position: relative;
    z-index: 4;
  }

  .v-main { background: transparent !important; }
  .v-main__wrap { background: transparent !important; }
}

.layout-auth__bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background:
    radial-gradient(ellipse 60% 50% at 50% 35%, rgba(30, 200, 214, 0.35), transparent 60%),
    radial-gradient(ellipse 80% 70% at 30% 80%, rgba(20, 80, 160, 0.4), transparent 65%),
    radial-gradient(ellipse 70% 60% at 75% 65%, rgba(15, 60, 140, 0.35), transparent 70%),
    linear-gradient(180deg, #06182f 0%, #04122a 100%);
}

.layout-auth__curves {
  position: fixed;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  opacity: 0.6;

  svg { width: 100%; height: 100%; }
  .curve {
    fill: none;
    stroke: rgba(108, 230, 240, 0.4);
    stroke-width: 1;
    stroke-linecap: round;
  }
  .curve--faint { stroke: rgba(108, 230, 240, 0.18); }
  .curve--glow {
    stroke: rgba(108, 230, 240, 0.7);
    stroke-width: 2;
    filter: blur(2px);
  }
}
</style>
